import { RootState } from '@/store/store';
import { GetterTree } from 'vuex';
import { AuditLogState } from './types/audit-log.types';

export const auditLogGetters: GetterTree<AuditLogState, RootState> = {};
